<mat-card
  id="procedures-card"
  class="has-progress-bar"
  [ngClass]="{
    'card-table': hasStudies,
    default: !hasStudies,
  }"
>
  <mat-progress-bar [mode]="(loading$ | async) ? 'indeterminate' : 'determinate'"></mat-progress-bar>
  <mat-card-title
    *appHasPermission="'appointment.edit'"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <span>{{ 'procedures-card.title' | translate }}</span>
    <button
      *ngIf="canEditCPT && canAddCPT"
      mat-stroked-button
      color="primary"
      class="new-cpt-button"
      [matTooltip]="'procedures-card.new-cpt-tooltip' | translate"
      (click)="openAddCPTDialog()"
    >
      <mat-icon>add</mat-icon>
      {{ 'procedures-card.new-cpt' | translate }}
    </button>
  </mat-card-title>

  <ng-container *ngIf="(studies$ | async) as studies; else loading">
    <mat-card-content *ngIf="studies?.length > 0; else noProducts" fxLayout="column">
      <table mat-table [dataSource]="studies">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'procedures-card.table.procedure' | translate }}
          </th>
          <td mat-cell *matCellDef="let study">
            <ng-container *ngIf="canEditProcedureConfig; else noEditPermission">
              <button
                mat-flat-button
                [matTooltip]="'procedures-card.table.procedure-tooltip' | translate: { name: study.productName }"
                (click)="openEditProduct(study)"
              >
                <span class="ellipsis">{{ study.productName }}</span>
              </button>
            </ng-container>
            <ng-template #noEditPermission>
              <span class="ellipsis" [matTooltip]="study.productName">{{ study.productName }}</span>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="eid">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'procedures-card.table.eid' | translate }}
          </th>
          <td mat-cell *matCellDef="let study">
            {{ study.eid }}
          </td>
        </ng-container>

        <ng-container matColumnDef="procedureCodes">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'procedures-card.table.procedureCodes' | translate }}
          </th>
          <td mat-cell *matCellDef="let study">
            {{ study.productCodes?.join(', ') }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'procedures-card.table.actions-header' | translate }}
          </th>
          <td mat-cell *matCellDef="let study">
            <ng-container *ngIf="canEditCPT && canEditRowCPT(study)">
              <button
                mat-icon-button
                class="edit-cpt-button"
                [attr.aria-label]="'procedures-card.table.edit-cpt' | translate"
                [matTooltip]="'procedures-card.table.edit-cpt' | translate"
                (click)="openEditCPTDialog(study)"
              >
                <mat-icon>edit</mat-icon>
              </button>
            </ng-container>
            <ng-container *ngIf="canDeleteCPT && canEditRowCPT(study)">
              <button
                mat-icon-button
                color="warn"
                class="delete-cpt-button"
                [disabled]="deletingProductId != null"
                [attr.aria-label]="'procedures-card.table.delete-cpt' | translate"
                [matTooltip]="'procedures-card.table.delete-cpt' | translate"
                (click)="deleteCptRow(study)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </mat-card-content>
  </ng-container>

  <ng-template #loading>
    <mat-card-content fxLayout="column">
      <p>
        {{ 'common.loading' | translate }}…
      </p>
    </mat-card-content>
  </ng-template>

  <ng-template #noProducts>
    <mat-card-content fxLayout="column">
      <div class="mmx-card-padding">
        {{ 'procedures-card.no-procedures' | translate }}
      </div>
    </mat-card-content>
  </ng-template>
</mat-card>
